/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */

import React from 'react'

export function IntermediateIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="18"
      viewBox="0 0 12 18"
      fill="none"
    >
      <path
        d="M15 8.56C15 8.70852 14.9473 8.85096 14.8536 8.95598C14.7598 9.061 14.6326 9.12 14.5 9.12H3.5C3.36739 9.12 3.24021 9.061 3.14645 8.95598C3.05268 8.85096 3 8.70852 3 8.56C3 8.41148 3.05268 8.26904 3.14645 8.16402C3.24021 8.059 3.36739 8 3.5 8H14.5C14.6326 8 14.7598 8.059 14.8536 8.16402C14.9473 8.26904 15 8.41148 15 8.56Z"
        fill="white"
      />
    </svg>
  )
}
